import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  inheritAttrs: false,
};

import { computed, ref } from '@nuxtjs/composition-api';

interface Props {
  id?: string | null;
  name?: string | null;
  placeholder?: string | null;
  value?: string | null;
  errors?: any[];
  block?: boolean;
  disabled?: boolean;
  loading?: boolean;
  countType?: string;
}

interface Emits {
  (e: 'input', data: Props['value']): void;
  (e: 'focus'): void;
  (e: 'blur'): void;
  (e: 'click'): void;
  (e: 'complete', data: any): void;
  (e: 'item-select', data: any): void;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'UiAutocomplete',
  props: {
    id: { default: null },
    name: { default: null },
    placeholder: { default: null },
    value: { default: null },
    errors: { default: () => [] },
    block: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    countType: { default: '' }
  },
  emits: ["input", "focus", "blur", "click", "complete", "item-select"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', data: Props['value']): void;
  (e: 'focus'): void;
  (e: 'blur'): void;
  (e: 'click'): void;
  (e: 'complete', data: any): void;
  (e: 'item-select', data: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { id: string | null, name: string | null, placeholder: string | null, value: string | null, errors: any[], block: boolean, disabled: boolean, loading: boolean, countType: string };





const valueLocal = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    // eslint-disable-next-line vue/require-explicit-emits
    emit('input', newValue);
  },
});
const autocomplete = ref();

return { __sfc: true,props, emit, valueLocal, autocomplete }
}

})